export const MAX_WORDS = 1000

export type MultiSelectField =
  | 'leetcode_difficulty'
  | 'codeforces_difficulty'
  | 'lesson_time_ist'
export type FormField =
  | 'email'
  | 'user_profiles'
  | MultiSelectField
  | 'lesson_frequency'
  | 'notes'
export type SignupStatus = 'idle' | 'saving-email' | 'submitting' | 'success'

export interface WaitlistFormData {
  email: string
  user_profiles: string
  leetcode_difficulty: string[]
  codeforces_difficulty: string[]
  lesson_time_ist: string[]
  lesson_frequency: string
  notes: string
}

export type UpdateFormValue = (
  value: string,
  key: FormField,
  multi?: boolean,
  isTextarea?: boolean
) => void

export const countWords = (value: string) =>
  value.trim() ? value.trim().split(/\s+/).length : 0
